import { FocusEvent, useState } from 'react'
import { useRecoilValue } from 'recoil'

import checkImg from '@/assets/common/input_complete_check.png'
import Timer from '@/shared/components/common/CommonForm/Timer'
import { COLOR } from '@/shared/constant/color'
import { TimeOutState } from '@/shared/store'
import { createTimerMonitor } from '@/shared/utils/sentry/timer'
import {
  InputCert,
  InputCertWrap,
  InputDefatultWrap,
  InputDefault,
  InputFormTitle,
  InputFormWrap,
  InputTelNum,
  InputTelNumWrap,
} from '@/styles/common/CommonForm/inputform'

const InputForm = (props: any) => {
  const [isShowErrMsg, setIsShowErrMsg] = useState<boolean>(false)
  const { title, placeholder, valid, check, value, ClickFunc, oninput } = props

  const TimeOut = useRecoilValue(TimeOutState)

  const monitorTimer = title.includes('인증번호')
  const [monitor] = useState(() => (monitorTimer ? createTimerMonitor() : null))

  const onKeyUpFunc = (event: any) => {
    if (check && event.keyCode === 13) {
      ClickFunc()
    }
  }

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    if (props.blurFunc) {
      setIsShowErrMsg(props.blurFunc(e))
    }
  }

  const InputFormContents = () => {
    switch (true) {
      case title.includes('휴대폰'):
        return (
          // refund 전용 조건
          <InputTelNumWrap
            bgColor={
              !window.location.pathname.includes('refund')
                ? COLOR.point1
                : check
                  ? COLOR.point1
                  : COLOR.gray30
            }
          >
            <InputTelNum
              id="phone_input"
              type="tel"
              placeholder={placeholder}
              onChange={valid}
              onKeyUp={onKeyUpFunc}
              onInput={oninput}
            />
            <button id="cert_button" onClick={ClickFunc}>
              인증번호 받기
            </button>
          </InputTelNumWrap>
        )
      case title.includes('인증번호'):
        return (
          <InputCertWrap>
            <div>
              <InputCert
                type="tel"
                placeholder={placeholder}
                onChange={valid}
                onInput={oninput}
                value={value}
                onBlur={handleBlur}
              />
              {TimeOut ? <Timer time={`${TimeOut}`} monitor={monitor} /> : <span>00:00</span>}
            </div>
            {isShowErrMsg && <span className="validate_check_msg">{props?.errMsg}</span>}
          </InputCertWrap>
        )
      case title === '연락처':
      case placeholder === '보안문자 입력':
        return (
          <InputDefatultWrap>
            <div>
              <InputDefault
                type={title === '연락처' ? 'tel' : 'text'}
                placeholder={placeholder}
                onChange={valid}
                onInput={oninput}
                value={value}
                onBlur={handleBlur}
              />
              {check && <img src={checkImg} alt="" />}
            </div>
            {isShowErrMsg && <span className="validate_check_msg">{props?.errMsg}</span>}
          </InputDefatultWrap>
        )
      default:
        return (
          <InputDefatultWrap>
            <div>
              <InputDefault
                type="text"
                placeholder={placeholder}
                onChange={valid}
                value={value}
                onInput={oninput}
                onBlur={handleBlur}
              />
              {check && <img src={checkImg} alt="" />}
            </div>
            {isShowErrMsg && <span className="validate_check_msg">{props?.errMsg}</span>}
          </InputDefatultWrap>
        )
    }
  }

  return (
    <InputFormWrap>
      <InputFormTitle display={`${title !== ''}`}>{title}</InputFormTitle>
      {InputFormContents()}
    </InputFormWrap>
  )
}
export default InputForm
